export const MOBILE_VIEW_SIZE = 850;

export const GRADE_KEY_CONST = [
      {grade:'A', status: 'Recommended', color: '#333', backgroundColor: '#aff1a9'},
      {grade:'B', status: 'Recommended', color: '#333', backgroundColor: '#aff1a9'},
      {grade:'C', status: 'Selectively Recommended', color: '#333', backgroundColor: '#eef1aa'},
      {grade:'D', status: 'Not Recommended', color: '#333', backgroundColor: '#f0a6a7'},
      {grade:'I', status: 'Uncertain', color: '#333', backgroundColor: '#cccccc'},
    ];

export const OFILTERSCONST = {
    keywords: {
        id: 'keywords',
        displayName: 'Keywords',
        values: []
    },
    age: {
        id: 'age',
        displayName: 'Age',
        values: [],
        unit: 'yr'
    },
    weight: {
        id: 'weight',
        displayName: 'Weight',
        values: [],
        unit: 'lb',
        system: 'US'
    },
    weightMetric: {
        id: 'weight',
        displayName: 'Weight',
        values: [],
        unit: 'kg',
        system: 'Metric'
    },
    height: {
        id: 'height',
        displayName: 'Height',
        values: [],
        unit: '',
        system: 'US'
    },
    heightFt: {
        id: 'heightFt',
        displayName: 'Height Ft',
        values: []
    },
    heightIn: {
        id: 'heightIn',
        displayName: 'Height In',
        values: []
    },
    heightMetric: {
        id: 'height',
        displayName: 'Height',
        values: [],
        unit: 'cm',
        system: 'Metric'
    },
    sex: {
        id: 'sex',
        displayName: 'Sex',
        options: [
            {display:'Male', value: 'Male', isActive: false}, 
            {display:'Female', value: 'Female', isActive: false}
            ],
        values: []
    },
    pregnant: {
        id: 'pregnant',
        displayName: 'Pregnant',
        options: [
            {display:'Yes', value: 'Y', isActive: false}, 
            {display:'No', value: 'N', isActive: false}
            ],
        values: [],
    },
    tobacco: {
        id: 'tobacco',
        displayName: 'Tobacco User - ever',
        options: [
            {display:'Yes', value: 'Y', isActive: false}, 
            {display:'No', value: 'N', isActive: false}
            ],
        values: [],
    },
    sexuallyActive: {
        id: 'sexually-active',
        displayName: 'Sexually Active',
        options: [
            {display:'Yes', value: 'Y', isActive: false}, 
            {display:'No', value: 'N', isActive: false}
            ],
        values: [],
    },
    grade: {
        id: 'grade',
        displayName: 'Grade',
        options: [
            {display:'All', values: ['A', 'B', 'C', 'D', 'I'], isActive: true}, 
            {display:'A', values: ['A'], isActive: false},
            {display:'B', values: ['B'], isActive: false},
            {display:'C', values: ['C'], isActive: false}, 
            {display:'D', values: ['D'], isActive: false},
            {display:'I', values: ['I'], isActive: false}
            ],
        values: ['A', 'B', 'C', 'D', 'I'],
    },
    lastupdated: {
        values: []
    }
  };

export const FILTERDEFAULT = JSON.parse(JSON.stringify(OFILTERSCONST));

//   export const FILTERDEFAULT = {
//     keywords: {
//         id: 'keywords',
//         displayName: 'Keywords',
//         values: []
//     },
//     age: {
//         id: 'age',
//         displayName: 'Age',
//         values: [],
//         unit: 'yr'
//     },
//     weight: {
//         id: 'weight',
//         displayName: 'Weight',
//         values: [],
//         unit: 'lb'
//     },
//     height: {
//         id: 'height',
//         displayName: 'Height',
//         values: [],
//     },
//     sex: {
//         id: 'sex',
//         displayName: 'Sex',
//         options: [
//             {display:'Male', value: 'Male', isActive: false}, 
//             {display:'Female', value: 'Female', isActive: false}
//             ],
//         values: [],
//     },
//     pregnant: {
//         id: 'pregnant',
//         displayName: 'Pregnant',
//         options: [
//             {display:'Yes', value: 'Y', isActive: false}, 
//             {display:'No', value: 'N', isActive: false}
//             ],
//         values: [],
//     },
//     tobacco: {
//         id: 'tobacco',
//         displayName: 'Tobacco User - ever',
//         options: [
//             {display:'Yes', value: 'Y', isActive: false}, 
//             {display:'No', value: 'N', isActive: false}
//             ],
//         values: [],
//     },
//     sexuallyActive: {
//         id: 'sexually-active',
//         displayName: 'Sexually Active',
//         options: [
//             {display:'Yes', value: 'Y', isActive: false}, 
//             {display:'No', value: 'N', isActive: false}
//             ],
//         values: [],
//     },
//     grade: {
//         id: 'grade',
//         displayName: 'Grade',
//         options: [
//             {display:'All', values: ['A', 'B', 'C', 'D', 'I'], isActive: true}, 
//             {display:'A & B', values: ['A', 'B'], isActive: false},
//             {display:'C', values: ['C'], isActive: false}, 
//             {display:'D', values: ['D'], isActive: false},
//             {display:'I', values: ['I'], isActive: false}
//             ],
//         values: ['A', 'B', 'C', 'D', 'I'],
//     }
//   };

  export const PRIMARY_COLOR = '#003d79';
  export const SECONDARY_COLOR = '#008ab0';
  export const ACCENT_COLOR = '#fe7e17';